export enum ProductShelfLifeUom {
  Days = "Days",
  Weeks = "Weeks",
  Months = "Months",
  Years = "Years",
}
